import React from "react";

const OrderConfirmedOrderInfo = ({
  promoCode,
  isLabOG,
  labName,
  pedido,
  prazo,
  observacao,
  promocaoNome,
}) => {
  const voucherPacto = observacao?.includes("Código Voucher Pacto")
    ? observacao?.match(/Código Voucher Pacto:\s*([A-Za-z0-9-]+)/)?.[1]?.trim() || ""
    : null;
  return (
    <div className="x-order-confirmed__list">
      {promoCode ? (
        <p className="x-order-confirmed__item">
          {isLabOG ? (
            <>
              <strong>
                Pedido EssilorLuxottica:{" "}
                <small className="x-order-confirmed__item--number">{pedido}</small>
              </strong>
            </>
          ) : (
            <>
              O número do seu pedido no <br />
              laboratório <small className="x-order-confirmed__item--lab">{labName}</small> é{" "}
              <small className="x-order-confirmed__item--number">{pedido}</small>
            </>
          )}
          <br />
          {voucherPacto && (
            <>
              Voucher Pacto: <br />
              <strong>{voucherPacto}</strong>
              <br />
            </>
          )}
          <strong>
            Cupom: <small className="x-order-confirmed__item--number">{promoCode}</small>
          </strong>
          <br />
        </p>
      ) : (
        <p className="x-order-confirmed__item">
          {isLabOG ? (
            <>
              <strong>
                Pedido EssilorLuxottica:{" "}
                <small className="x-order-confirmed__item--number">{pedido}</small>
              </strong>
            </>
          ) : (
            <>
              O número do seu pedido no <br />
              laboratório <small className="x-order-confirmed__item--lab">{labName}</small> é{" "}
              <small className="x-order-confirmed__item--number">{pedido}</small>
            </>
          )}
          <br />
          {voucherPacto && (
            <>
              Voucher Pacto: <br />
              <small className="x-order-confirmed__item--lab">{voucherPacto}</small>
            </>
          )}
          {promocaoNome && (
            <strong>
              Promoção: <small className="x-order-confirmed__item--number">{promocaoNome}</small>
            </strong>
          )}
        </p>
      )}

      {(!promoCode || !isLabOG)&& (
        <p style={{ textAlign: "center" }} className="x-order-confirmed__item js--paragraph">
          A data de saída estimada é <br />
          <small className="x-order-confirmed__item--number">{prazo}</small>
        </p>
      )}
    </div>
  );
};

export default OrderConfirmedOrderInfo;